import { render, staticRenderFns } from "./SelectorBanco.vue?vue&type=template&id=a871d478&scoped=true"
import script from "./SelectorBanco.vue?vue&type=script&lang=js"
export * from "./SelectorBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a871d478",
  null
  
)

export default component.exports